import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./subscribe-press-list.module.scss"
import LogoType from "../../../helpers/logo-type"
import Heading from "../../atoms/heading"

const SubscribePressList = ({ press, label, light, center }) => {
  if (press && press.length > 0)
    return (
      <div className={`${styles.press} ${center ? styles.press__center : ""}`}>
        <Heading level="5" semantic={false}>
          {label}:
        </Heading>
        {press.map((item) => (
          <a key={item.url} href={item.url} target="_blank" rel="noreferrer">
            <Image
              {...LogoType(light, item.logo, item.dark_logo)}
              width={50}
              alt={item.name}
              className={styles.pressImage}
            />
          </a>
        ))}
      </div>
    )
  return null
}

export default SubscribePressList

SubscribePressList.propTypes = {
  press: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  light: PropTypes.bool,
  center: PropTypes.bool,
}

SubscribePressList.defaultProps = {
  light: false,
  center: false,
}
